import React from 'react';

import { Image, Center, ModalContent } from '@chakra-ui/react';
import { Carousel as ReactCarousel } from 'react-responsive-carousel';

import { Icon } from 'components/icon';
import { Modal } from 'components/modal';

interface CarouselModalProps {
  isOpen: boolean
  onClose: () => void
  images: string[]
}

export default function CarouselModal({
  isOpen, onClose, images = [],
}:CarouselModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}>
      <ModalContent
        maxW="50%"
        maxH="80%"
        alignSelf="center"
        alignItems="center">
        <ReactCarousel
          infiniteLoop
          showStatus={false}
          renderArrowNext={(onClickHandler, visible) => (
            <Center
              hidden={!visible}
              zIndex={110}
              cursor="pointer"
              onClick={onClickHandler}
              position="absolute"
              top="50%"
              right={5}>
              <Icon
                color="gray.500"
                name="angle-right"
                size="xl"
              />
            </Center>
          )}
          renderArrowPrev={(onClickHandler, visible) => (
            <Center
              hidden={!visible}
              zIndex={110}
              cursor="pointer"
              onClick={onClickHandler}
              position="absolute"
              top="50%"
              left={5}>
              <Icon
                color="gray.500"
                name="angle-left"
                size="xl"
              />
            </Center>
          )}>
          {images.map((url) => (
            <Image
              pt={10}
              px={10}
              alignSelf="center"
              h={500}
              objectFit="contain"
              key={url}
              borderRadius={4}
              src={url}
            />
          ))}
        </ReactCarousel>
      </ModalContent>
    </Modal>
  );
}
